<template>
  <div>
    <div v-show="isLoading" class="loader">
      <b-spinner class="align-middle mb-3" />
      <strong>Loading...</strong>
    </div>

    <div v-show="!isLoading">
      <div v-if="importResult?.failed_count === 0" class="card p-4">
        <div class="success text-center">
          <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
          <h5 class="mt-2 mb-3">
            {{ $t('global.title.importResult') }}
          </h5>
          <p>{{ $t('delivery.upload.successUpload.subtitle') }}</p>
        </div>
      </div>

      <template v-else>
        <McAlert
          withIcon
          variant="error"
          class="alert-error mb-4"
          :text="$t('global.importResult.invalidTemplate')"
        />
        <b-tabs v-model="activeTab" lazy>
          <b-tab title="Informasi Dasar" class="card p-4">
            <Table :fields="deliveryOrderFields" :listGetter="fetchData" />
          </b-tab>
          <b-tab title="Muatan" class="card p-4">
            <Table :fields="loadFields" :listGetter="fetchData" />
          </b-tab>
        </b-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import uploadSuccessImg from '@/assets/images/upload-success.png'
import McAlert from '@/components/McAlert'
import Table from '../components/Table'

import { deliveryOrderFields, loadFields } from '../lib/uploadResultFields'

import { getImportResult } from '@/services/rest-api/lib/delivery/import'

import { mapState } from 'vuex'

const resourceTypes = ['order', 'load']

export default {
  components: {
    Table,
    McAlert,
  },
  data() {
    return {
      activeTab: 0,
      deliveryOrderFields,
      loadFields,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('delivery', ['importResult']),
    uploadSuccessImg() {
      return uploadSuccessImg
    },
    fields() {
      return []
    },
  },
  beforeDestroy() {
    this.resetImportResult()
  },
  methods: {
    async fetchData(opts) {
      // For showing initial loader
      if (!this.importResult) {
        this.isLoading = true
      }

      const res = await getImportResult(this.$route.params.id, {
        ...opts,
        resource: resourceTypes[this.activeTab],
        format: 'json',
      })

      if (!res || res.errors) return

      // Only set metadata on initial load
      if (!this.importResult) {
        const { failed_count, success_count, processed_count } = res.metadata
        this.$store.dispatch('delivery/setImportResult', {
          failed_count,
          success_count,
          total_count: processed_count,
        })
      }

      this.isLoading = false

      return res
    },
    resetImportResult() {
      this.$store.dispatch('delivery/setImportResult', null)
    },
  },
}
</script>
<style lang="scss" scoped>
.alert-error {
  width: fit-content;
}

.loader {
  min-height: min(50vh, 500px);
  display: grid;
  place-items: center;
  place-content: center;
  background-color: white;
}
</style>
